import { FONT_SIZE_CLASS_NAME } from '../constants/responsive-class-names';

const hasAutoFillMarker = (token) => token.split('[')[0].split(':').includes('auto');

const isTextAutofillToken = (token, className) =>
  hasAutoFillMarker(token) && token.includes(`auto:${className}-`);

const getTokenBreakpoint = (token) => {
  const colonIndex = token.indexOf(':');
  return colonIndex >= 0 ? token.substring(0, colonIndex) : '';
};

const stripTextAutofillClasses = (currentClass, className = FONT_SIZE_CLASS_NAME, breakpoint) =>
  currentClass
    .split(' ')
    .filter((token) => {
      if (!token) return false;
      if (!isTextAutofillToken(token, className)) return true;
      if (breakpoint === undefined) return false;
      return getTokenBreakpoint(token) !== breakpoint;
    })
    .join(' ');

export default stripTextAutofillClasses;
